import React from "react";
import Money from "../../img/data-cuate.png";

export default function Content() {
  return (
    <>
      <div className="max-w-2xl mx-auto py-10 px-4 grid items-center grid-cols-1 gap-y-10 gap-x-8 sm:px-6 sm:py-10 lg:max-w-7xl lg:px-8 lg:grid-cols-2">
        <div>
          <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl  pb-4">
            About Our Technology
          </h2>
          <p className="mt-1 text-gray-500 pb-2">
            Many people rely on subjective technical analysis and incomplete
            market information to select their options trades, often with
            disappointing results.
          </p>
          <p className="mt-1 text-gray-500 pb-2">
            PayCoLife was developed by Excelscion Analytics, LLC with the
            independent trader in mind. A better solution is needed when faced
            with multi-billion dollar organizations that always rely on
            computerized trading algorithms and advanced artificial
            intelligence.
          </p>
          <p className="mt-1 text-gray-500 pb-2">
            PayCoLife is a powerful and cost-effective solution for you that
            uses trained machine learning models to select the best and
            best-selling products with the highest probability of profit and
            provides its users with a tool that allows them to Implement an
            efficient balancing system.
          </p>
        </div>
        <div>
          <img
            src={Money}
            alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
            className="bg-gray-100 rounded-lg"
          />
        </div>
      </div>
    </>
  );
}
